import { render } from "./Alumno.vue?vue&type=template&id=2b46e3ec&scoped=true"
import script from "./Alumno.vue?vue&type=script&lang=js"
export * from "./Alumno.vue?vue&type=script&lang=js"

import "./Alumno.vue?vue&type=style&index=0&id=2b46e3ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b46e3ec"]])

export default __exports__